/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminTenantTenantConfigIdDelete$Params {
  tenantConfigId: string;
}

export function adminTenantTenantConfigIdDelete(http: HttpClient, rootUrl: string, params: AdminTenantTenantConfigIdDelete$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminTenantTenantConfigIdDelete.PATH, 'delete');
  if (params) {
    rb.path('tenantConfigId', params.tenantConfigId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MPIStrictHttpResponse<void>;
    })
  );
}

adminTenantTenantConfigIdDelete.PATH = '/Admin/tenant/{tenantConfigId}';
